import { _ } from "../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import OldSpinnerWidget from "../../deprecated/OldSpinnerWidget/OldSpinnerWidget.js"; // eslint-disable-line import-x/no-deprecated -- todo: migrate to new spinner
import ValidationResultWidget from "../widgets/ValidationResultWidget.js";

/**
 * `wizardStepWidget` renders a wizard's current step.
 *
 * @param {Wizard} wizard - The wizard whose current step is to
 *   be rendered
 * @param {SupportInfo} [supportInfo] - Contact information to display
 *   in case of an error
 */
export default class WizardStepWidget extends Widget {
	constructor({ wizard, supportInfo }) {
		super(...arguments);

		this._wizard = wizard;

		this._wizard.currentStepSubmitted.register(() =>
			this._updateCollector(),
		);

		this._wizard.currentStepChanged.register(() => this._updateCollector());

		this._validationResultWidget = new ValidationResultWidget({
			supportInfo,
		});

		// eslint-disable-next-line import-x/no-deprecated -- todo: migrate to new spinner
		this._spinner = new OldSpinnerWidget({ size: 64 });
	}

	renderContentOn(html) {
		if (this._wizard.currentStepIsSubmitting()) {
			html.render(this._spinner);
			return;
		}

		this._renderStepRenderableOn(html);
		this._renderStepExceptionsOn(html);

		if (this._canIgnoreWarnings()) {
			html.button(
				{ klass: "btn btn-warning", type: "button" },
				_("Ignore warnings"),
			).click(() => this._wizard.ignoreWarnings());
		}
	}

	_getCollector() {
		return this._wizard.currentStepSubmitExceptions();
	}

	_updateCollector() {
		this._validationResultWidget.setCollector(this._getCollector());
	}

	_canIgnoreWarnings() {
		return (
			this._getCollector().hasWarning() &&
			!this._getCollector().hasError()
		);
	}

	_renderStepRenderableOn(html) {
		html.render(this._wizard.stepRenderable());
	}

	_renderStepExceptionsOn(html) {
		html.render(this._validationResultWidget);
	}
}
